import { EntityFile } from "../../entity/EntityFile";

export class DtoFilesDeleteRes extends EntityFile {
  public message: string | null = null;
}
